"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MembersDay',
  props: {
    pageKey: {
      type: String,
      default: 'memberDay'
    },
    moduleKey: {
      type: String,
      default: '11-1'
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchName: '',
      imagePrefix: '',
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      // 抽屉相关数据
      drawerVisible: false,
      drawerTitle: '添加会员日活动',
      isEdit: false,
      editIndex: -1,
      // 预览相关数据
      previewVisible: false,
      previewImageUrl: '',
      // 表单数据
      formData: {
        mainTitle: '',
        subTitle: '',
        remark: '',
        startBg1: '',
        startBg2: '',
        notStartBg: '',
        notStartTime: '',
        notStartEndTime: '',
        enabled: true,
        rightsModules: [{
          image: '',
          sort: '1',
          title: ''
        }],
        pointsLotteryImage: '',
        pointsRightsTitle: '',
        pointsLotteryId: '',
        lotteryType: 'community',
        flashSaleTitle: '',
        flashSales: [{
          id: '',
          sort: '1'
        }],
        pointsRedemption: '',
        pointsExchanges: [{
          id: '',
          sort: '1'
        }],
        templateSorts: {
          doublePoints: '1',
          flashSale: '2',
          coupon: '3',
          lottery: '4',
          exchange: '5'
        },
        shareTitle: '',
        startTime: '',
        endTime: ''
      },
      // 表单验证规则
      formRules: {
        mainTitle: [{
          required: true,
          message: '请输入大标题',
          trigger: 'blur'
        }],
        subTitle: [{
          required: true,
          message: '请输入小标题',
          trigger: 'blur'
        }],
        pointsRightsTitle: [{
          required: true,
          message: '请输入积分权益标题',
          trigger: 'blur'
        }],
        pointsLotteryId: [{
          required: true,
          message: '请输入积分抽奖ID',
          trigger: 'blur'
        }],
        flashSaleTitle: [{
          required: true,
          message: '请输入秒杀权益标题',
          trigger: 'blur'
        }],
        pointsRedemption: [{
          required: true,
          message: '请输入积分兑换权益',
          trigger: 'blur'
        }],
        shareTitle: [{
          required: true,
          message: '请输入页面分享标题',
          trigger: 'blur'
        }],
        // 活动时间验证（自定义验证）
        activityTime: [{
          required: true,
          validator: this.validateActivityTime,
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
  },
  methods: {
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    handleSearch: function () {
      var _handleSearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 搜索时重置到第一页
              this.currentPage = 1;
              // 调用接口进行搜索
              _context2.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('搜索完成');
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleSearch() {
        return _handleSearch.apply(this, arguments);
      }
      return handleSearch;
    }(),
    handleAdd: function () {
      var _handleAdd = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.isEdit = false;
              this.currentId = null;
              this.drawerTitle = '添加会员日活动';
              this.resetForm();
              this.drawerVisible = true;
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleAdd() {
        return _handleAdd.apply(this, arguments);
      }
      return handleAdd;
    }(),
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var loadingInstance, response, detailData, extraData, _t2;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              loadingInstance = null;
              _context4.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context4.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context4.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.isEdit = true;
                this.currentId = detailData.id;
                this.drawerTitle = '编辑会员日活动';
                this.loadFormData(extraData);
                this.drawerVisible = true;
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t2 = _context4["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t2);
              this.$message.error('加载详情失败: ' + (_t2.message || '未知错误'));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$confirm('确认删除该记录吗？', '提示', {
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var response, _t3;
                return regeneratorRuntime.wrap(function (_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;
                      _context5.next = 1;
                      return (0, _decorateConfigItem.deleteConfigItem)(row.id);
                    case 1:
                      response = _context5.sent;
                      if (!(response.code === 200)) {
                        _context5.next = 3;
                        break;
                      }
                      _context5.next = 2;
                      return _this.loadConfig();
                    case 2:
                      _this.$message.success('删除成功');
                      _context5.next = 4;
                      break;
                    case 3:
                      _this.$message.error(response.message || '删除失败!');
                    case 4:
                      _context5.next = 6;
                      break;
                    case 5:
                      _context5.prev = 5;
                      _t3 = _context5["catch"](0);
                      console.error('删除失败:', _t3);
                      _this.$message.error('删除失败: ' + (_t3.message || '未知错误'));
                    case 6:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5, null, [[0, 5]]);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('会员日配置保存成功');
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(row) {
        var _loading, response, _t4;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              // 显示预览loading状态
              _loading = this.$loading({
                lock: true,
                text: '预览中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口预览配置 第二个参数小程序标识
              _context8.next = 1;
              return (0, _decorateConfigItem.generateQrCode)(row.id, this.xcxType);
            case 1:
              response = _context8.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data && response.data.image) {
                  // 显示预览弹窗
                  this.previewImageUrl = response.data.image;
                  this.previewVisible = true;
                } else {
                  this.$message.success('预览成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context8.next = 3;
              break;
            case 2:
              _context8.prev = 2;
              _t4 = _context8["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('预览失败:', _t4);
              this.$message.error('预览失败: ' + (_t4.message || '未知错误'));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function handlePreview(_x3) {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    handleApply: function () {
      var _handleApply = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('会员日配置应用成功');
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleApply() {
        return _handleApply.apply(this, arguments);
      }
      return handleApply;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    handleToggleVisible: function () {
      var _handleToggleVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(row) {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              _context0.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context0.sent;
              if (!(response.code === 200)) {
                _context0.next = 3;
                break;
              }
              _context0.next = 2;
              return this.loadConfig();
            case 2:
              this.$message.success("\u66F4\u65B0\u6210\u529F");
              _context0.next = 4;
              break;
            case 3:
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              this.$message.error(response.message || '操作失败!');
            case 4:
              _context0.next = 6;
              break;
            case 5:
              _context0.prev = 5;
              _t5 = _context0["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              console.error('操作失败:', _t5);
              this.$message.error('操作失败: ' + (_t5.message || '未知错误'));
            case 6:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[0, 5]]);
      }));
      function handleToggleVisible(_x4) {
        return _handleToggleVisible.apply(this, arguments);
      }
      return handleToggleVisible;
    }(),
    // 添加分页相关方法
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 每页大小改变时回到第一页
      this.loadConfig(); // 重新加载配置
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.loadConfig(); // 重新加载配置
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var loadingInstance, response, _t6;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              loadingInstance = null;
              _context1.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context1.next = 2;
                break;
              }
              return _context1.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context1.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize, this.searchName);
            case 3:
              response = _context1.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                this.list = response.records.map(function (item) {
                  var extra = item.extra ? JSON.parse(item.extra) : {};
                  return _objectSpread(_objectSpread(_objectSpread({}, item), extra), {}, {
                    // 保持启用状态字段名称一致
                    enable: item.enable
                  });
                });
                this.total = response.total;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context1.next = 5;
              break;
            case 4:
              _context1.prev = 4;
              _t6 = _context1["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t6);
              this.$message.error('配置加载失败: ' + (_t6.message || '未知错误'));
            case 5:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 抽屉相关方法
    handleDrawerClose: function handleDrawerClose() {
      this.drawerVisible = false;
      this.resetForm();
    },
    handleConfirm: function () {
      var _handleConfirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.$refs.membersDayForm.validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(valid) {
                  var loadingInstance, data, response, _t7;
                  return regeneratorRuntime.wrap(function (_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!valid) {
                          _context10.next = 9;
                          break;
                        }
                        if (_this2.validateImages()) {
                          _context10.next = 1;
                          break;
                        }
                        return _context10.abrupt("return");
                      case 1:
                        loadingInstance = null;
                        _context10.prev = 2;
                        data = {
                          id: _this2.isEdit ? _this2.currentId : null,
                          pageCode: _this2.pageKey,
                          optionCode: _this2.moduleKey,
                          title: _this2.formData.mainTitle,
                          enable: _this2.formData.enabled,
                          extra: JSON.stringify(_objectSpread({}, _this2.formData))
                        }; // 显示保存loading状态
                        loadingInstance = _this2.$loading({
                          lock: true,
                          text: '保存中...',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 调用后端接口保存配置
                        _context10.next = 3;
                        return (0, _decorateConfigItem.saveConfigItem)(data);
                      case 3:
                        response = _context10.sent;
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        if (!(response.code === 200)) {
                          _context10.next = 5;
                          break;
                        }
                        // 保存成功后关闭对话框
                        _this2.drawerVisible = false;
                        // 刷新列表数据
                        _context10.next = 4;
                        return _this2.loadConfig();
                      case 4:
                        _this2.$message.success(_this2.isEdit ? '编辑成功' : '添加成功');
                        _context10.next = 6;
                        break;
                      case 5:
                        _this2.$message.error(response.message || '保存失败!');
                      case 6:
                        _context10.next = 8;
                        break;
                      case 7:
                        _context10.prev = 7;
                        _t7 = _context10["catch"](2);
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        console.error('保存失败:', _t7);
                        _this2.$message.error('保存失败: ' + (_t7.message || '未知错误'));
                      case 8:
                        _context10.next = 10;
                        break;
                      case 9:
                        _this2.$message.error('请填写必填项');
                      case 10:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10, null, [[2, 7]]);
                }));
                return function (_x5) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function handleConfirm() {
        return _handleConfirm.apply(this, arguments);
      }
      return handleConfirm;
    }(),
    resetForm: function resetForm() {
      this.formData = {
        mainTitle: '',
        subTitle: '',
        remark: '',
        startBg1: '',
        startBg2: '',
        notStartBg: '',
        notStartTime: '',
        notStartEndTime: '',
        enabled: true,
        rightsModules: [{
          image: '',
          sort: '1',
          title: ''
        }],
        pointsLotteryImage: '',
        pointsRightsTitle: '',
        pointsLotteryId: '',
        lotteryType: 'community',
        flashSaleTitle: '',
        flashSales: [{
          id: '',
          sort: '1'
        }],
        pointsRedemption: '',
        pointsExchanges: [{
          id: '',
          sort: '1'
        }],
        templateSorts: {
          doublePoints: '1',
          flashSale: '2',
          coupon: '3',
          lottery: '4',
          exchange: '5'
        },
        shareTitle: '',
        startTime: '',
        endTime: ''
      };
      if (this.$refs.membersDayForm) {
        this.$refs.membersDayForm.clearValidate();
      }
    },
    // 处理时间变化
    handleTimeChange: function handleTimeChange() {
      // 手动触发表单验证
      this.$refs.membersDayForm.validateField('activityTime');
    },
    // 校验活动时间
    validateActivityTime: function validateActivityTime(rule, value, callback) {
      if (!this.formData.startTime) {
        callback(new Error('请选择活动开始时间'));
      } else if (!this.formData.endTime) {
        callback(new Error('请选择活动结束时间'));
      } else {
        callback();
      }
    },
    // 校验图片是否已上传
    validateImages: function validateImages() {
      // 校验活动开始背景图1
      if (!this.formData.startBg1) {
        this.$message.error('请上传活动开始背景图1');
        return false;
      }

      // 校验活动开始背景图2
      if (!this.formData.startBg2) {
        this.$message.error('请上传活动开始背景图2');
        return false;
      }

      // 校验活动未开始背景图
      if (!this.formData.notStartBg) {
        this.$message.error('请上传活动未开始背景图');
        return false;
      }

      // 校验积分抽奖图
      if (!this.formData.pointsLotteryImage) {
        this.$message.error('请上传积分抽奖图');
        return false;
      }

      // 校验权益模块图片
      for (var i = 0; i < this.formData.rightsModules.length; i++) {
        var item = this.formData.rightsModules[i];
        if (!item.image) {
          this.$message.error("\u8BF7\u4E0A\u4F20\u7B2C".concat(i + 1, "\u4E2A\u6743\u76CA\u6A21\u5757\u7684\u56FE\u7247"));
          return false;
        }
      }
      return true;
    },
    loadFormData: function loadFormData(row) {
      // 确保row存在，如果不存在则使用空对象
      var data = row || {};

      // 加载编辑数据到表单
      this.formData = {
        mainTitle: data.title || data.mainTitle || '',
        subTitle: data.subTitle || '',
        remark: data.remark || '',
        startBg1: data.startBg1 || '',
        startBg2: data.startBg2 || '',
        notStartBg: data.notStartBg || '',
        notStartTime: data.notStartTime || '',
        notStartEndTime: data.notStartEndTime || '',
        enabled: data.enabled !== undefined ? data.enabled : data.enable !== undefined ? data.enable : data.onShelf !== undefined ? data.onShelf : true,
        rightsModules: data.rightsModules || [{
          image: '',
          sort: '1',
          title: ''
        }],
        pointsLotteryImage: data.pointsLotteryImage || '',
        pointsRightsTitle: data.pointsRightsTitle || '',
        pointsLotteryId: data.pointsLotteryId || '',
        lotteryType: data.lotteryType || 'community',
        flashSaleTitle: data.flashSaleTitle || '',
        flashSales: data.flashSales || [{
          id: '',
          sort: '1'
        }],
        pointsRedemption: data.pointsRedemption || '',
        pointsExchanges: data.pointsExchanges || [{
          id: '',
          sort: '1'
        }],
        templateSorts: data.templateSorts || {
          doublePoints: '1',
          flashSale: '2',
          coupon: '3',
          lottery: '4',
          exchange: '5'
        },
        shareTitle: data.shareTitle || '',
        startTime: data.startTime || (data.dateRange ? data.dateRange[0] : ''),
        endTime: data.endTime || (data.dateRange ? data.dateRange[1] : '')
      };
    },
    // 图片上传相关方法
    uploadImage: function uploadImage(type) {
      this.createFileInput(type);
    },
    uploadRightsImage: function uploadRightsImage(index) {
      this.createFileInput('rightsImage', index);
    },
    createFileInput: function createFileInput(type) {
      var _this3 = this;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.style.display = 'none';
      input.onchange = function (e) {
        var file = e.target.files[0];
        if (file) {
          _this3.handleImageUpload(file, type, index);
        }
      };
      document.body.appendChild(input);
      input.click();
      document.body.removeChild(input);
    },
    handleImageUpload: function () {
      var _handleImageUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(file, type) {
        var index,
          _loading2,
          response,
          imageUrl,
          _args12 = arguments,
          _t8;
        return regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              index = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : null;
              if (file.type.startsWith('image/')) {
                _context12.next = 1;
                break;
              }
              this.$message.error('请选择图片文件');
              return _context12.abrupt("return");
            case 1:
              _context12.prev = 1;
              // 显示上传loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传图片
              _context12.next = 2;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 2:
              response = _context12.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                imageUrl = response.data;
                if (type === 'rightsImage') {
                  // 权益模块图片
                  this.$set(this.formData.rightsModules[index], 'image', imageUrl);
                } else {
                  // 其他图片
                  this.$set(this.formData, type, imageUrl);
                }
                this.$message.success('图片上传成功!');
              } else {
                this.$message.error(response.message || '图片上传失败!');
              }
              _context12.next = 4;
              break;
            case 3:
              _context12.prev = 3;
              _t8 = _context12["catch"](1);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('图片上传失败:', _t8);
              this.$message.error('图片上传失败: ' + (_t8.message || '未知错误'));
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[1, 3]]);
      }));
      function handleImageUpload(_x6, _x7) {
        return _handleImageUpload.apply(this, arguments);
      }
      return handleImageUpload;
    }(),
    // 删除图片
    // 动态添加/删除方法
    addRightsModule: function addRightsModule() {
      this.formData.rightsModules.push({
        image: '',
        sort: String(this.formData.rightsModules.length + 1),
        title: ''
      });
    },
    removeRightsModule: function removeRightsModule(index) {
      if (this.formData.rightsModules.length > 1) {
        this.formData.rightsModules.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个权益模块');
      }
    },
    addFlashSale: function addFlashSale() {
      this.formData.flashSales.push({
        id: '',
        sort: String(this.formData.flashSales.length + 1)
      });
    },
    removeFlashSale: function removeFlashSale(index) {
      if (this.formData.flashSales.length > 1) {
        this.formData.flashSales.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个秒杀配置');
      }
    },
    addPointsExchange: function addPointsExchange() {
      this.formData.pointsExchanges.push({
        id: '',
        sort: String(this.formData.pointsExchanges.length + 1)
      });
    },
    removePointsExchange: function removePointsExchange(index) {
      if (this.formData.pointsExchanges.length > 1) {
        this.formData.pointsExchanges.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个积分兑换配置');
      }
    }
  }
};